import { SERVICE } from '@src/constants';
import { IAM_CLIENT_ID, IAM_REALM, IAM_URL } from '@src/configs';
import snakecaseKeys from 'snakecase-keys';
import api from './api';

export const checkUserPermission = async ({ method, uri }) => {
  const res = await api({
    method: 'GET',
    url: '/auth/check-route-permission',
    params: { method, uri },
    source: SERVICE.ACCOUNT,
  });
  return res;
};

export const checkPermittedMenus = async () => {
  const res = await api({
    method: 'GET',
    url: '/auth/permitted-menus',
    source: SERVICE.ACCOUNT,
  });
  return res;
};

export const login = async ({ email, password }) => {
  const res = await api({
    method: 'POST',
    url: `${IAM_URL}/auth/realms/${IAM_REALM}/protocol/openid-connect/token`,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: new URLSearchParams(
      snakecaseKeys({
        grant_type: 'password',
        client_id: IAM_CLIENT_ID,
        username: email,
        password,
      }),
    ),
    source: SERVICE.IAM,
  });

  return res;
};
